import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const PARTNER_CUSTOMER_DETAIL_QUERY_KEY = (customerId: number) => [
  'GET_PARTNER_CUSTOMER_DETAIL',
  customerId,
];

export const useGetPartnerCustomerDetailQuery = (customerId: number) => {
  const { getPartnerCustomerDetail } = useServicesContext();

  return useQuery({
    queryKey: PARTNER_CUSTOMER_DETAIL_QUERY_KEY(customerId),
    queryFn: () => getPartnerCustomerDetail(customerId),
    enabled: !!customerId,
  });
};
